import { render } from "./LoggedInNav.vue?vue&type=template&id=5724f39d&scoped=true"
import script from "./LoggedInNav.vue?vue&type=script&lang=js"
export * from "./LoggedInNav.vue?vue&type=script&lang=js"

import "./LoggedInNav.vue?vue&type=style&index=0&id=5724f39d&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5724f39d"]])

export default __exports__